import { Users, Eye, RotateCw, UserMinus, CalendarClock, GitBranch } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PAINS = [
  { icon: Users, title: "Todo sigue dependiendo de ti", text: "Cada decisión, cada problema y cada cliente importante terminan en tu escritorio." },
  { icon: Eye, title: "Nadie ve lo que tú ves", text: "La visión está en tu cabeza, pero no en la de tu equipo. Cada uno ejecuta su propia versión de lo que cree que importa." },
  { icon: RotateCw, title: "Los problemas se repiten", text: "Se apagan incendios, pero el mismo issue vuelve a aparecer en distintas formas." },
  { icon: UserMinus, title: "Sabes quién no debería estar en el equipo — y no haces nada", text: "Lo has pensado mil veces. Pero la conversación se posterga, y el resto del equipo ya lo sabe." },
  { icon: CalendarClock, title: "Muchas reuniones, poca ejecución", text: "Se conversa mucho, se acuerda poco y los compromisos rara vez se cumplen." },
  { icon: GitBranch, title: "La complejidad crece más rápido que el negocio", text: "Más personas, más procesos, más áreas… y menos foco." },
];

export default function PainPoints() {
  return (
    <section data-testid="pain-section" className="section-padding bg-slate-50/60">
      <div className="container-eos">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">El síntoma</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
            Tu empresa crece, pero{" "}
            <span className="text-[#F26522]">¿sientes que pierdes el control?</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            Estas son las seis frustraciones más comunes de un Empresario. Si te identificas, EOS te puede ayudar.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PAINS.map((p, i) => (
            <article
              key={i}
              data-testid={`pain-card-${i + 1}`}
              className="card-soft p-5 reveal"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-center justify-between">
                <div className="w-9 h-9 rounded-lg bg-[#F26522]/10 flex items-center justify-center">
                  <p.icon className="w-4 h-4 text-[#F26522]" strokeWidth={1.7} />
                </div>
                <span className="font-display font-bold text-slate-200 text-xl tabular-nums">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-4 font-display font-bold text-base text-navy-800 leading-snug">
                {p.title}
              </h3>
              <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{p.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 reveal">
          <Link
            to="/dolores-del-empresario"
            data-testid="pain-section-see-all-link"
            className="inline-flex items-center gap-2 text-sm font-bold text-[#F26522] hover:underline"
          >
            Ver cómo se resuelve cada uno <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
